export default '/@lang/pages/@slug'
